// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3GQL3","content":"styles_content__13V10","selectAll":"styles_selectAll__3iKh4"};